export enum USERS_DOMAIN {
  LIST = 'list',
}

export const USERS_DOMAIN_KEY = 'users';
